import { render, staticRenderFns } from "./TelephoneServer.vue?vue&type=template&id=a90a5b12"
import script from "./TelephoneServer.vue?vue&type=script&lang=js"
export * from "./TelephoneServer.vue?vue&type=script&lang=js"
import style0 from "./TelephoneServer.vue?vue&type=style&index=0&id=a90a5b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports